import React, { useState } from "react";
import { Link } from "react-router-dom";
import icn from "../../Images/gift-icon.png";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

// Demo styles, see 'Styles' section below for some notes on use.
import "react-accessible-accordion/dist/fancy-example.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  OwnWalletDetails,
  RewardHistoryDetails,
} from "../../Redux/Slice/Offer";
import { getOwnProfile } from "../../Redux/Slice/PostSlice";

function RewardPointsSummary() {
  const dispatch = useDispatch();
  const { WalletData, RewardHistoryDetailsData } = useSelector(
    (state) => state.offer
  );
  const { UserProfileID } = useSelector((state) => state.app);
  const [MemberShipPoints, setMemberShipPoints] = useState(0);
  const [RedeemingPoints, setRedeemingPoints] = useState(0);
  const [GetPointSummary, setGetPointSummary] = useState(0);
  const [MemberAddPoint, setMemberAddPoint] = useState(0);
  const [NonMemberAddPoint, setNonMemberAddPoint] = useState(0);
  const [RedeemEarnedPoint, setRedeemEarnedPoint] = useState(0);

  const nonPurchaseWalletOffer = WalletData?.filter(
    (item) => !item?.voucherReedem
  );

  useEffect(() => {
    if (WalletData) {
      setRedeemingPoints(
        WalletData?.reduce(
          (total, offer) => total + offer.Offer.reddemingPoints,
          0
        )
      );
    }
  }, [WalletData]);
  useEffect(() => {
    if (RewardHistoryDetailsData) {
      setMemberShipPoints(
        RewardHistoryDetailsData?.filter(
          (item, i) => item?.type == "memberAdd"
        )?.reduce((total, offer) => total + offer.points, 0)
      );
      setGetPointSummary(
        RewardHistoryDetailsData?.filter(
          (item, i) =>
            item?.type != "memberAdd" &&
            item?.type != "memSave" &&
            item?.type != "nonMemSave" &&
            item?.type != "redeemPoint"
        )?.reduce((total, offer) => total + offer.points, 0)
      );
      setMemberAddPoint(
        RewardHistoryDetailsData?.filter(
          (item, i) => item?.type == "memSave"
        )?.reduce((total, offer) => total + offer.points, 0)
      );
      setNonMemberAddPoint(
        RewardHistoryDetailsData?.filter(
          (item, i) => item?.type == "nonMemSave"
        )?.reduce((total, offer) => total + offer.points, 0)
      );
      setRedeemEarnedPoint(
        RewardHistoryDetailsData?.filter(
          (item, i) => item?.type == "redeemPoint"
        )?.reduce((total, offer) => total + offer.points, 0)
      );
    }
  }, [RewardHistoryDetailsData]);
  useEffect(() => {
    dispatch(OwnWalletDetails());
    dispatch(getOwnProfile());
    dispatch(RewardHistoryDetails());
  }, []);

  return (
    <>
      <section className="rewardpointssummary_sec">
        <div className="cust_container">
          <div className="top_area">
            <Link to="/reward" className="backbtn">
              <i className="fa-solid fa-arrow-left-long"></i>
            </Link>
            <h4 className="heading">Points Summary</h4>
            <Link to="/my-wallet">
              <div className="icon">
                <img src={icn} className="img-fluid" alt="....." />
                {nonPurchaseWalletOffer?.length > 0 && (
                  <span className="notification_count">
                    {nonPurchaseWalletOffer?.length}
                  </span>
                )}
              </div>
            </Link>
          </div>

          <div className="rewardpoint_table">
            <ul>
              <li>
                <h6 className="point">{UserProfileID?.rewardPoints} Points </h6>
                <p className="text">Your total earned points</p>
              </li>
              <li>
                <h6 className="point">{RedeemingPoints} Points </h6>
                <p className="text">Redeemed points</p>
              </li>
            </ul>
          </div>

          <div className="pointbreak_up">
            <h4 className="head">Your point break up</h4>

            <Accordion>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="d-flex">
                      <span className="icomimg1">
                        <i className="fa-solid fa-cart-shopping"></i>
                      </span>
                      <div>
                        <p>Neoo search Membership </p>
                        <span>Earned {MemberShipPoints} points</span>
                      </div>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    By purchasing the Neoo Search Business Pack, you become a member of the Neoo Business Club and earn 1,500 points.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="d-flex">
                      <span className="icomimg1">
                        <i className="fa-solid fa-users"></i>
                      </span>
                      <div>
                        <p>Member to Member added points</p>
                        <span>Earned {MemberAddPoint} points</span>
                      </div>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    For each member you add to your Neoo directory, you earn 500 points, helping you connect your business more effectively with customers.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="d-flex">
                      <span className="icomimg1">
                        <i className="fa-solid fa-users-viewfinder"></i>
                      </span>
                      <div>
                        <p>Premium Member to NeooCard Member Added Points</p>
                        <span>Earned {NonMemberAddPoint} points</span>
                      </div>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    For each NeooCard member you add to your Neoo Search directory, you earn 250 points, helping you expand your business reach.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="d-flex">
                      <span className="icomimg1">
                        <i className="fa-solid fa-chart-line"></i>
                      </span>
                      <div>
                        <p>Neoo search profile activities</p>
                        <span>Earned {GetPointSummary} points</span>
                      </div>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    You can earn rewards by interacting with Neoo Search member profiles:
                  </p>
                  <ul>
                    <li>Like a member profile: 250 points</li>
                    <li>Call through the Neoo Search profile: 50 points</li>
                    <li>WhatsApp contact: 50 points</li>
                    <li>Visit website link: 200 points</li>
                    <li>Visit social media links: 100 points per link</li>
                    <li>View products: 100 points for each product view</li>
                    <li>Watch profile video: 150 points</li>
                    <li>Download PDF profile: 200 points</li>
                  </ul>
                  <p style={{ marginTop: 20 }}>Rate the profile</p>
                  <ul style={{ listStyleType: "circle" }}>
                    <li>1 Star: 50 points</li>
                    <li>2 Star: 100 points</li>
                    <li>3 Star: 150 points</li>
                    <li>4 Star: 200 points</li>
                    <li>5 Star: 250 points</li>
                  </ul>

                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="d-flex">
                      <span className="icomimg1">
                        <i className="fa-solid fa-gift"></i>
                      </span>
                      <div>
                        <p>Redeem offers</p>
                        <span>Earned {RedeemEarnedPoint} points</span>
                      </div>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    You receive 300 points back when you redeem each offer.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </>
  );
}

export default RewardPointsSummary;
